/**
 * Announcement Service
 * Handles API calls for popup announcements
 */

const DEFAULT_PAGE = 'home-v3'

export const announcementService = {
  /**
   * Fetch active announcements for a specific page
   * @param {Object} httpInstance - Axios instance (this.$http)
   * @param {String} page - Vue route name ('home-v3', 'deposit-v3', …)
   * @returns {Promise<Array>} - Array of announcements
   */
  async fetchAnnouncements(httpInstance, page = DEFAULT_PAGE) {
    try {
      const response = await httpInstance.get('/member/popup-announcements', {
        params: { page }
      })

      if (response.data.success && Array.isArray(response.data.data)) {
        return response.data.data
      }

      return []
    } catch (error) {
      console.error(
        '[AnnouncementService] Failed to fetch announcements:',
        error.message
      )
      return []
    }
  },

  /**
   * Dismiss an announcement (don't show again)
   * @param {Object} httpInstance - Axios instance (this.$http)
   * @param {Number|String} announcementId - ID of the announcement to dismiss
   * @returns {Promise<Boolean>} - Success status
   */
  async dismissAnnouncement(httpInstance, announcementId) {
    try {
      const response = await httpInstance.post(
        `/member/popup-announcements/${announcementId}/dismiss`
      )

      return response.data.success === true
    } catch (error) {
      console.error(
        '[AnnouncementService] Failed to dismiss announcement:',
        error.message
      )
      return false
    }
  },

  /**
   * Map route name to the `page` query parameter.
   *
   * popup_announcements.target_page stores the Vue ROUTE NAME verbatim
   * ('home-v3', 'deposit-v3', 'promotion-v3', …) or 'all' — see
   * src/router/index.js. The allowed values are enforced server-side by
   * Agent-Core-Service PopupAnnouncementService.TARGET_PAGES and picked from a
   * dropdown in Agent-Backoffice (agent Detail → ป๊อปอัพประกาศ), so nothing has
   * to be translated here. Adding a new route means adding it to those two
   * lists, not to this function.
   *
   * @param {String} routeName - Vue route name
   * @returns {String} - Page parameter for API
   */
  getPageFromRoute(routeName) {
    return routeName || DEFAULT_PAGE
  }
}

export default announcementService
